import z from "zod/v4";

export const country = z.enum(["Israel", "Germany", "USA"]);

export type Country = z.infer<typeof country>;

export const supportedCountries: Country[] = [...country.options];

export const countryDetails: Record<
  Country,
  { cities: string[]; timezone: string; isoCode: string }
> = {
  Israel: { cities: [], timezone: "Asia/Jerusalem", isoCode: "IL" },
  Germany: { cities: ["Berlin"], timezone: "Europe/Berlin", isoCode: "DE" },
  USA: { cities: ["NYC"], timezone: "America/New_York", isoCode: "US" },
};
